module.exports = __webpack_public_path__ + "static/img/guanyuwomen@1x.2c4527a.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/guanyuwomen@1x.png
// module id = 7rcW
// module chunks = 2